export enum TimeFrame {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
}

export const TIME_FRAMES = [
  {
    value: TimeFrame.DAILY,
    label: 'Daily',
  },
  {
    value: TimeFrame.WEEKLY,
    label: 'Weekly',
  },
  {
    value: TimeFrame.MONTHLY,
    label: 'Monthly',
  },
] as const;

export enum WidgetId {
  VolumeOverTime = 'volumeOverTime',
  ModalityDistribution = 'modalityDistribution',
  PreciseHeatmap = 'preciseHeatmap',
  VolumeByCountry = 'volumeByCountry',
}

export const DEFAULT_WIDGET_ORDER = [
  WidgetId.VolumeOverTime,
  WidgetId.ModalityDistribution,
  WidgetId.PreciseHeatmap,
  WidgetId.VolumeByCountry,
] as const;

export enum VolumeOverTimeFilter {
  SubCategory = 'sub-category',
  Impact = 'impact',
  Type = 'type',
  None = 'none',
}

export enum VolumeOverTimeFilterValue {
  SUB_CATEGORY = 'sub-category',
  IMPACT = 'impact',
  TYPE = 'type',
  NONE = 'none',
}

export const VOLUME_OVER_TIME_FILTERS = [
  {
    value: VolumeOverTimeFilterValue.SUB_CATEGORY,
    label: 'By Category',
  },
  {
    value: VolumeOverTimeFilterValue.IMPACT,
    label: 'By Impact',
  },
  {
    value: VolumeOverTimeFilterValue.TYPE,
    label: 'By Type',
  },
  {
    value: VolumeOverTimeFilterValue.NONE,
    label: 'Total',
  },
] as const;

export const DEFAULT_TIME_FRAME: TimeFrame = TimeFrame.DAILY;
export const TIMESERIES_TOP_N = 10;
